import React from 'react';
import { ArrowRightIcon, LockIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type CtaButtonProps = {
  label: string;
  id?: string;
  className?: string;
};
export function CtaButton({
  label,
  id,
  className = ''
}: CtaButtonProps) {
  return <a id={id} href={CHECKOUT_URL} className={`group flex w-full items-center justify-center gap-3 rounded-2xl border-b-4 border-cta-dark bg-cta px-5 py-[18px] text-center text-[16px] font-extrabold uppercase leading-tight tracking-wide text-white shadow-cta transition-[transform,background-color] duration-150 ease-out hover:-translate-y-0.5 hover:bg-cta-hover active:translate-y-0.5 focus-visible:outline focus-visible:outline-4 focus-visible:outline-offset-2 focus-visible:outline-gold sm:text-lg ${className}`} data-id="element-87" data-mp="ckso2fez56f9">
      <span className="text-balance" data-id="element-88" data-mp="19c386vutagzi">{label}</span>
      <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-89" data-mp="198p9bxlcwpwt" />
    </a>;
}
type SectionCtaProps = {
  label: string;
  dark?: boolean;
};
export function SectionCta({
  label,
  dark = false
}: SectionCtaProps) {
  return <div className="mx-auto mt-10 w-full max-w-xl" data-id="element-90" data-mp="3exu9i69b2kds">
      <CtaButton label={label} data-id="element-91" data-mp="3ex2sc0gggp71" />
      <p className={`mt-3 flex items-center justify-center gap-1.5 text-xs font-medium sm:text-sm ${dark ? 'text-white/70' : 'text-muted'}`} data-id="element-92" data-mp="3f071zdcowd53">
        <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-93" data-mp="3owtk3udmsq3f" />
        Secure checkout · One-time payment of $27
      </p>
    </div>;
}